import { render, staticRenderFns } from "./WizardTitleDecorationIcon.vue?vue&type=template&id=daf40a58&scoped=true&"
import script from "./WizardTitleDecorationIcon.vue?vue&type=script&lang=ts&"
export * from "./WizardTitleDecorationIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf40a58",
  null
  
)

export default component.exports